import React from 'react';
import { topCasinos } from '../../../mocks/casinos';

export const TopCasinosSection: React.FC = () => {
  return (
    <section className="py-20 bg-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-serif text-gray-600 mb-2">Обновлено в январе 2026</p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-2">
            ТОП казино онлайн
          </h2>
          <p className="text-3xl font-serif italic text-gray-700">России 2026</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {topCasinos.map((casino) => (
            <div
              key={casino.id}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className={`${casino.bgColor} h-64 flex items-center justify-center p-6 relative overflow-hidden`}>
                <img
                  src={casino.image}
                  alt={casino.name}
                  className="w-full h-full object-cover rounded-2xl"
                />
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{casino.name}</h3>
                
                <div className="flex items-center gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <i
                      key={i}
                      className={`ri-star-fill text-lg ${
                        i < Math.floor(casino.rating) ? 'text-yellow-400' : 'text-gray-300'
                      }`}
                    ></i>
                  ))}
                  <span className="text-sm text-gray-600 ml-1">{casino.rating}</span>
                </div>

                <div className="flex flex-wrap gap-2 mb-4">
                  {casino.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="text-xs px-3 py-1 bg-gray-100 text-gray-700 rounded-full"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                <div className="mb-4">
                  <p className="text-sm text-gray-600 mb-1">Бонус:</p>
                  <p className="text-lg font-bold text-blue-600">{casino.bonus}</p>
                </div>

                <button className="w-full py-3 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer">
                  Играть
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};